<template>
  <div>
    <div @click="closeVideo" ref="vidWrap" class="vid__wrapper">
      <div class="vid__lightbox">
        <div class="vid__lightbox-content">
          <button class="btn btn__close" @click="closeVideo">Close</button>
          <div class="vid__embed">
            <iframe
              ref="youtubeEmbed"
              id="youtube-embed"
              width="100%"
              height="400"
              src="https://www.youtube.com/embed/QCshuJ-Fmt0?showinfo=0&controls=0"
              frameborder="0"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
    <template v-if="loadingUser">
      <div class="div__loading">
        <loader/>
      </div>
    </template>
    <template v-else>
      <main>
        <section class="main__grid">
          <div class="courses__tabs">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <!-- <li class="nav-item">
                <a class="nav-link " id="credentials-tab" data-toggle="tab" href="#credentials" role="tab" aria-controls="credentials" aria-selected="false">Credentials</a>
              </li>-->
              <template>
                <li class="nav-item">
                  <a
                    class="nav-link active"
                    id="settings-tab"
                    data-toggle="tab"
                    href="#settings"
                    role="tab"
                    aria-controls="settings"
                    aria-selected="false"
                  >Edit Profile</a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="courses-tab"
                    data-toggle="tab"
                    href="#courses"
                    role="tab"
                    aria-controls="courses"
                    aria-selected="true"
                  >Courses</a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="certificate-tab"
                    data-toggle="tab"
                    href="#certificate"
                    role="tab"
                    aria-controls="certificate"
                    aria-selected="false"
                  >Certificates</a>
                </li>

                <!--<li class="nav-item">-->
                <!--<a class="nav-link" id="bank-tab" data-toggle="tab" href="#bank" role="tab" aria-controls="bank" aria-selected="false">Bank Acc.</a>-->
                <!--</li>-->
                <!--<li class="nav-item">-->
                <!--<a class="nav-link" id="jobs-tab" data-toggle="tab" href="#jobs" role="tab" aria-controls="jobs" aria-selected="false">Jobs</a>-->
                <!--</li>-->
                <!--<template v-if="userObject.is_psychometric_completed === 1">-->
                <!--<li class="nav-item">-->
                <!--<a class="nav-link" id="reports-tab" data-toggle="tab" href="#reports" role="tab" aria-controls="reports" aria-selected="false">Reports</a>-->
                <!--</li>-->
                <!--</template>-->
              </template>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div
                class="tab-pane fade active show"
                id="settings"
                role="tabpanel"
                aria-labelledby="settings-tab"
              >
                <h5 class="bold">Edit your profile</h5>
                <div class="section__body settings">
                  <div class="settings__side">
                    <form class="form__settings" method="post" @submit.prevent="updateUser" action>
                      <div class="form-row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for>First Name</label>
                            <input
                              class="form-control"
                              type="text"
                              value
                              :class="[{'is-invalid': errors.fname}]"
                              @keydown="clearErrors($event.target.name)"
                              v-model="itemData.fname"
                            >
                            <div class="invalid-feedback">{{ errors.fname }}</div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for>Last Name</label>
                            <input
                              class="form-control"
                              type="text"
                              value
                              :class="[{'is-invalid': errors.lname}]"
                              @keydown="clearErrors($event.target.name)"
                              v-model="itemData.lname"
                            >
                            <div class="invalid-feedback">{{ errors.lname }}</div>
                          </div>
                        </div>
                      </div>

                      <div class="form-row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label for>Email Address</label>
                            <input
                              class="form-control"
                              type="email"
                              value
                              disabled
                              :class="[{'is-invalid': errors.email}]"
                              @keydown="clearErrors($event.target.name)"
                              v-model="itemData.email"
                            >
                            <div class="invalid-feedback">{{ errors.email }}</div>
                          </div>
                        </div>
                      </div>

                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <label for>Phone Number</label>
                          <input
                            class="form-control"
                            type="text"
                            value
                            disabled
                            :class="[{'is-invalid': errors.phone}]"
                            @keydown="clearErrors($event.target.name)"
                            v-model="itemData.phone"
                          >
                          <div class="invalid-feedback">{{ errors.phone }}</div>
                        </div>
                      </div>

                      <div class="btn__group btn__group--form">
                        <button class="btn__grey btn__primary--lg">Cancel</button>
                        <button
                          type="submit"
                          class="btn__primary btn--lg btn__primary--alt"
                          @click.prevent="updateUser"
                          v-bind="{'disabled': loading}"
                        >Save</button>
                      </div>
                    </form>
                  </div>
                  <div class="settings__side">
                    <div class="settings__wrap">
                      <img
                        class="settings__avatar"
                        v-if="itemData.avatar"
                        :src="itemData.avatar"
                        alt="Profile picture"
                      >
                      <img v-else class="settings__avatar" src="../../assets/img/profile.jpg" alt>
                      <label class="edit-icon" for="upload-image">
                        <input
                          @change="changeAvatar"
                          ref="avatar"
                          class="avatar__input"
                          type="file"
                          id="upload-image"
                          accept="image/*"
                        >
                        <svg width="28" height="27" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M3.88 19.4v4.22h4.21l12.45-12.44-4.22-4.22L3.87 19.4zM23.8 7.92c.44-.44.44-1.15 0-1.59L21.17 3.7a1.12 1.12 0 0 0-1.59 0l-2.06 2.06 4.22 4.22 2.06-2.06z"
                            fill="#fff"
                          ></path>
                        </svg>
                      </label>
                      <div v-if="isUploadingAvatar" class="loading">
                        <Loader/>
                      </div>
                    </div>
                    <div class="invalid-feedback">{{errors.avatar}}</div>
                  </div>
                </div>
              </div>

              <div
                class="tab-pane fade"
                id="credentials"
                role="tabpanel"
                aria-labelledby="credentials-tab"
                ref="credentialsTab"
              >
                <div
                  v-if="!userObject.is_credential_uploaded"
                  class="alert alert-warning"
                  role="alert"
                >
                  <strong>Next Step!</strong> Please upload credentials to proceed to the next phase.
                </div>
                <div
                  v-else-if="!userObject.is_psychometric_completed"
                  class="alert alert-info"
                  role="alert"
                >
                  <strong>Next Step!</strong> Click
                  <router-link class="bold" :to="{name: 'test'}">here to proceed</router-link>to take the personality test.
                </div>
                <div
                  v-else-if="!userObject.is_career_selected"
                  class="alert alert-info"
                  role="alert"
                >
                  <strong>Next Up!</strong> Please select a career path to proceed to the next phase.
                  <router-link to="/careers">
                    <strong>Click here to go to careers</strong>
                  </router-link>
                </div>
                <br>
                <h5 class="bold">Upload Credentials</h5>
                <div class="section__body credentials">
                  <template v-if="showCredential">
                    <CredentialModal :credential="selectedCredential"/>
                    <div class="btn--wrap">
                      <button
                        @click="{showCredential = false}"
                        type="button"
                        class="btn btn__green"
                      >Back</button>
                    </div>
                  </template>
                  <template v-else>
                    <form @submit.prevent="uploadCredential" class="upload">
                      <label
                        class="label"
                        for="credential-title"
                      >You can upload your credentials here</label>
                      <select
                        class="custom-select form-control"
                        id="credential-title"
                        name="title"
                        :class="[{'is-invalid': errors.title}]"
                        @change="clearErrors($event.target.name)"
                        v-model="credentialData.title"
                      >
                        <option value disabled>Select credential type</option>
                        <option value="FSLC">First School Leaving Certificate</option>
                        <option value="WAEC">West African Examination Council(WAEC)</option>
                        <option value="BSc">University Degree(Bsc, BTech)</option>
                        <option value="HND">Polytechnic Degree</option>
                        <option value="NCE">Nigerian Certificate in Education(NCE)</option>
                        <option value="MSc">Master's Degree(MSc)</option>
                        <option value="PhD">Doctorate Degree(PhD)</option>
                        <option value="other">Others</option>
                      </select>
                      <div v-if="credentialData.title === 'other'" class="form-group">
                        <input
                          id="title"
                          class="form-control"
                          placeholder="Credential Type"
                          type="text"
                          v-model="title"
                          :class="[{'is-invalid': errors.title}]"
                          @keydown="clearErrors($event.target.name)"
                        >
                      </div>
                      <div class="invalid-feedback">{{ errors.title }}</div>
                      <div class="upload__section">
                        <div class="upload__wrapper">
                          <input
                            class="upload__input"
                            role="button"
                            @change="addCredential"
                            ref="credentials"
                            name="file"
                            type="file"
                            accept="image/*"
                            placeholder="Upload File"
                          >
                          <button
                            type="submit"
                            @click.prevent="uploadCredential"
                            class="btn__primary btn__primary--upload"
                          >
                            Upload File
                            <Loader v-if="isUploadingCredential" class="loading loading--alt"/>
                          </button>
                        </div>
                      </div>
                      <div class="invalid-feedback">{{ errors.credential }}</div>
                    </form>

                    <div class="credentials__status">
                      <template v-if="credentialsLoaded && credentialsList.length">
                        <div
                          v-for="credential in credentialsList"
                          :key="credential.id"
                          :credential="credential"
                          class="section__row credentials__item"
                        >
                          <span class="credentials__title">{{credential.title}}</span>
                          <span>{{credentialStatus(credential.status)}}</span>
                          <div class="credentials__btn-grp">
                            <button class="btn__grey" @click="selectCredential(credential)">View</button>
                            <button class="btn__danger" @click="deleteCredential(credential)">Delete</button>
                          </div>
                        </div>
                      </template>
                      <template v-else-if="credentialsLoaded">No credentials uploaded yet</template>
                      <template v-else>Error loading credentials</template>
                    </div>
                  </template>
                </div>
              </div>
              <div class="tab-pane fade" id="courses" role="tabpanel" aria-labelledby="courses-tab">
                <div class="section__row section__row--between">
                  <h5 class="bold">Courses</h5>
                </div>
                <div class="main__grid courses__tabs__main">
                  <template v-if="courses && courses.length > 0">
                    <div class="courses__item" v-for="item in courses" :key="item.id">
                      <div class="courses__item__heading">
                        <span>
                          <svg
                            width="30"
                            height="30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17.5 2.5h-10A2.5 2.5 0 0 0 5.01 5L5 25a2.5 2.5 0 0 0 2.49 2.5H22.5A2.5 2.5 0 0 0 25 25V10l-7.5-7.5zm2.5 20H10V20h10v2.5zm0-5H10V15h10v2.5zm-3.75-6.25V4.37l6.88 6.88h-6.88z"
                              fill="#209DA3"
                            ></path>
                          </svg>
                        </span>
                        <router-link
                          :to="{
														name: 'course-detail',
														params: { id: item.class_id }
													}"
                        >
                          <span class="bold">{{ item.class.title }}</span>
                        </router-link>
                      </div>
                      <span>{{ item.created_at | date }}</span>
                      <p class="pt-10" v-html="item.class.description"></p>
                    </div>
                  </template>
                  <template v-else>
                    <div>No courses taken yet</div>
                  </template>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="certificate"
                role="tabpanel"
                aria-labelledby="certificate-tab"
              >
                <template v-if="showCertificate">
                  <Certificate
                    :created_at="certificateData.created_at"
                    :title="certificateData.title"
                    :score="certificateData.score"
                  />
                  <div class="btn--wrap">
                    <button
                      @click="{showCertificate = false}"
                      type="button"
                      class="btn btn__green"
                    >Back</button>
                  </div>
                </template>
                <template v-else>
                  <div class="section__row section__row--between">
                    <h5 class="bold">Certificates</h5>
                    <a class="link" href>View all certificates</a>
                  </div>
                  <div class="main__grid certificate">
                    <template v-if="certificatesLoaded && certificates.length">
                      <div
                        v-for="certificate in certificates"
                        class="grid__item"
                        :key="certificate.id"
                      >
                        <img class="certificate__img" :src="certificate.class.avatar" alt>
                        <span class="text">{{certificate.class.title}}</span>
                        <span>Score: {{certificate.score}}</span>
                        <button
                          @click="setCertificateData(certificate)"
                          type="button"
                          class="btn btn__green"
                        >View</button>
                      </div>
                    </template>
                    <template v-else-if="certificatesLoaded">No Certificates awarded yet</template>
                    <template v-else>Error Loading certificates</template>
                  </div>
                </template>
              </div>
              <div
                class="tab-pane fade"
                id="settings"
                role="tabpanel"
                aria-labelledby="settings-tab"
              >
                <h5 class="bold">Edit your profile</h5>
                <div class="section__body settings">
                  <div class="settings__side">
                    <form class="form__settings" method="post" @submit.prevent="updateUser" action>
                      <div class="form-row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for>First Name</label>
                            <input
                              class="form-control"
                              type="text"
                              value
                              :class="[{'is-invalid': errors.fname}]"
                              @keydown="clearErrors($event.target.name)"
                              v-model="itemData.fname"
                            >
                            <div class="invalid-feedback">{{ errors.fname }}</div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for>Last Name</label>
                            <input
                              class="form-control"
                              type="text"
                              value
                              :class="[{'is-invalid': errors.lname}]"
                              @keydown="clearErrors($event.target.name)"
                              v-model="itemData.lname"
                            >
                            <div class="invalid-feedback">{{ errors.lname }}</div>
                          </div>
                        </div>
                      </div>

                      <div class="form-row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label for>Email Address</label>
                            <input
                              class="form-control"
                              type="email"
                              value
                              disabled
                              :class="[{'is-invalid': errors.email}]"
                              @keydown="clearErrors($event.target.name)"
                              v-model="itemData.email"
                            >
                            <div class="invalid-feedback">{{ errors.email }}</div>
                          </div>
                        </div>
                      </div>

                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <label for>Phone Number</label>
                          <input
                            class="form-control"
                            type="text"
                            value
                            disabled
                            :class="[{'is-invalid': errors.phone}]"
                            @keydown="clearErrors($event.target.name)"
                            v-model="itemData.phone"
                          >
                          <div class="invalid-feedback">{{ errors.phone }}</div>
                        </div>
                      </div>

                      <div class="btn__group btn__group--form">
                        <button class="btn__grey btn__primary--lg">Cancel</button>
                        <button
                          type="submit"
                          class="btn__primary btn--lg btn__primary--alt"
                          @click.prevent="updateUser"
                          v-bind="{'disabled': loading}"
                        >Save</button>
                      </div>
                    </form>
                  </div>
                  <div class="settings__side">
                    <div class="settings__wrap">
                      <img
                        class="settings__avatar"
                        v-if="itemData.avatar"
                        :src="itemData.avatar"
                        alt="Profile picture"
                      >
                      <img v-else class="settings__avatar" src="../../assets/img/profile.jpg" alt>
                      <label class="edit-icon" for="upload-image">
                        <input
                          @change="changeAvatar"
                          ref="avatar"
                          class="avatar__input"
                          type="file"
                          id="upload-image"
                          accept="image/*"
                        >
                        <svg width="28" height="27" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M3.88 19.4v4.22h4.21l12.45-12.44-4.22-4.22L3.87 19.4zM23.8 7.92c.44-.44.44-1.15 0-1.59L21.17 3.7a1.12 1.12 0 0 0-1.59 0l-2.06 2.06 4.22 4.22 2.06-2.06z"
                            fill="#fff"
                          ></path>
                        </svg>
                      </label>
                      <div v-if="isUploadingAvatar" class="loading">
                        <Loader/>
                      </div>
                    </div>
                    <div class="invalid-feedback">{{errors.avatar}}</div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="bank" role="tabpanel" aria-labelledby="bank-tab">
                <h5 class="bold">Update Bank details</h5>
                <div class="section__body settings">
                  <div class="settings__side">
                    <form class="form__settings" @submit.prevent="updateBank" action>
                      <div class="form-row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label for>Bank Name</label>
                            <input
                              class="form-control"
                              type="text"
                              value
                              :class="[{'is-invalid': errors.bank_name}]"
                              @keydown="clearErrors($event.target.name)"
                              v-model="bank.bank_name"
                            >
                            <div class="invalid-feedback">{{ errors.bank_name }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for>Account Name</label>
                            <input
                              class="form-control"
                              type="text"
                              value
                              :class="[{'is-invalid': errors.account_name}]"
                              @keydown="clearErrors($event.target.name)"
                              v-model="bank.account_name"
                            >
                            <div class="invalid-feedback">{{ errors.account_name }}</div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for>Account Number</label>
                            <input
                              class="form-control"
                              type="number"
                              value
                              :class="[{'is-invalid': errors.account_number}]"
                              @keydown="clearErrors($event.target.name)"
                              v-model="bank.account_number"
                            >
                            <div class="invalid-feedback">{{ errors.account_number }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <label for>BVN</label>
                          <input
                            class="form-control"
                            type="number"
                            value
                            :class="[{'is-invalid': errors.bvn}]"
                            @keydown="clearErrors($event.target.name)"
                            v-model="bank.bvn"
                          >
                          <div class="invalid-feedback">{{ errors.bvn }}</div>
                        </div>
                      </div>
                      <div class="btn__group btn__group--form">
                        <button class="btn__grey btn__primary--lg">Cancel</button>
                        <button
                          class="btn__primary btn--lg btn__primary--alt"
                          @click.prevent="updateBank"
                          v-bind="{'disabled': loading}"
                        >Save</button>
                      </div>
                    </form>
                  </div>
                  <div class="settings__side">
                    <div v-if="bank.bank_name" class="form__wrapper">
                      <div class="form-row">
                        <div class="col-md-12">
                          <span class="bold">Bank Name:</span>
                          {{ bank.bank_name }}
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="col-md-12">
                          <span class="bold">Account Name:</span>
                          {{ bank.account_name }}
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="col-md-12">
                          <span class="bold">Account Number:</span>
                          {{ bank.account_number }}
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="col-md-12">
                          <span class="bold">BVN:</span>
                          {{ bank.bvn }}
                        </div>
                      </div>
                    </div>
                    <div class="invalid-feedback">{{errors.avatar}}</div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="jobs"
                role="tabpanel"
                aria-labelledby="job-tab"
                ref="jobTab"
              >
                <div class="section__row section__row--between">
                  <h5 class="bold">Jobs</h5>
                </div>
                <div class="main__grid courses__tabs__main">
                  <template v-if="jobs && jobs.length > 0">
                    <div class="courses__item" v-for="item in jobs" :key="item.id">
                      <div class="courses__item__heading">
                        <span>
                          <svg
                            width="30"
                            height="30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17.5 2.5h-10A2.5 2.5 0 0 0 5.01 5L5 25a2.5 2.5 0 0 0 2.49 2.5H22.5A2.5 2.5 0 0 0 25 25V10l-7.5-7.5zm2.5 20H10V20h10v2.5zm0-5H10V15h10v2.5zm-3.75-6.25V4.37l6.88 6.88h-6.88z"
                              fill="#209DA3"
                            ></path>
                          </svg>
                        </span>
                        <router-link
                          :to="{
                                                        name: 'job-detail',
                                                        params: { id: item.job_id }
                                                    }"
                        >
                          <span class="bold">{{ item.job.title }}</span>
                        </router-link>
                      </div>
                      <span>{{ item.job.created_at | date }}</span>
                    </div>
                  </template>
                  <template v-else-if="jobsLoaded">You have not applied for any job yet.</template>
                  <template v-else>Error loading jobs.</template>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="reports"
                role="tabpanel"
                aria-labelledby="report-tab"
                ref="reportTab"
              >
                <div class="section__body settings">
                  <Reports/>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import {
  getUserProfile,
  updateUser,
  updateAvatar,
  uploadCredential,
  getUserCredentials,
  getUserCertificates,
  updateBank,
  deleteCredential,
  getUserJobs,
  getUserBadges
} from "../../utils/api/user";
import form from "../../mixins/form";
import user from "../../utils/validations/user";
import { success, fail } from "../../utils/toast";
import Loader from "../../components/Loader";
import Certificate from "../../components/Certificate";
import CredentialModal from "./CredentialModal";
import eventHub from "../../utils/eventhub";
import Reports from "../../components/Reports";

export default {
  name: "UserProfile",
  mixins: [form],
  data() {
    return {
      title: "",
      itemData: {},
      userLoaded: false,
      errors: {},
      loadingUser: false,
      avatar: "",
      courses: {},
      isUploadingAvatar: false,
      avatarUploaded: false,
      credentialData: { title: "" },
      isUploadingCredential: false,
      credentialUploaded: false,
      credentialsList: [],
      loadingCredentials: false,
      credentialsLoaded: false,
      certificates: [],
      loadingCertificates: false,
      certificatesLoaded: false,
      certificateData: {},
      showCertificate: false,
      badgesLoaded: false,
      loadingBadges: false,
      Badges: [],
      bank: {},
      showCredential: false,
      selectedCredential: {},
      skillsets: [],
      loadingSkillsets: true,
      skillsetsLoaded: false,
      jobs: [],
      loadingJobs: true,
      jobsLoaded: false,
      player: null
    };
  },
  mounted() {
    if (this.userObject.is_credential_uploaded === 0) {
      this.showVideo();
    }

    window.onYoutubeIframeAPIReady = () => {
      this.player = new YT.Player("youtube-embed", {
        events: {
          onReady: window.onPlayerReady,
          onStateChange: window.onPlayerStateChange
        }
      });
    };
    window.onPlayerStateChange = e => {
      if (e.data === 0) {
        this.closeVideo();
      }
    };
  },
  created() {
    this.getUserCredentials();
    if (
      this.userObject.is_credential_uploaded === 1 &&
      this.userObject.is_psychometric_completed === 1
    ) {
      this.getUserProfile();
      this.getCertificates();
      this.getUserJobs();
      this.getUserBadges();
      eventHub.$on("credential-selected", payload => {
        this.selectedCredential = payload;
      });
      return true;
    }
    return false;
  },
  methods: {
    showVideo() {
      const vid = this.$refs.youtubeEmbed.src;
      this.$refs.youtubeEmbed.src = `${vid}&autoplay=1`;
      this.$refs.vidWrap.style.display = "block";
    },
    closeVideo() {
      const vid = this.$refs.youtubeEmbed.src;
      const resetVid = vid.replace("&autoplay=1", "");
      this.$refs.youtubeEmbed.src = resetVid;
      this.$refs.vidWrap.style.display = "none";
    },
    setCertificateData(data) {
      this.certificateData = {};
      this.certificateData.title = data.class.title;
      this.certificateData.score = data.score;
      this.certificateData.created_at = data.created_at;

      this.showCertificate = true;
    },
    getCertificates() {
      getUserCertificates(this.$session.get("id"))
        .then(response => {
          if (response.status === 200) {
            this.certificatesLoaded = true;
            const result = response.data.data;
            result.map(item => {
              if (item.score >= item.class.pass_grade) {
                this.certificates.push(item);
              }
              return true;
            });
            return true;
          }
          return false;
        })
        .catch(error => {
          this.certificatesLoaded = false;
          return error;
        })
        .finally(() => {
          this.loadingCertificates = false;
        });
      return true;
    },
    getUserBadges() {
      this.loadingBadges = true;
      getUserBadges(this.$session.get("id"))
        .then(response => {
          if (response.status === 200) {
            this.badges = response.data.data;
            this.badgesLoaded = true;
            return true;
          }
          this.badgesLoaded = false;
          return false;
        })
        .catch(error => {
          this.loadingBadges = false;
          return error;
        })
        .finally(() => {
          this.loadingBadges = false;
        });
    },
    getUserCredentials() {
      this.loadingCredentials = true;
      getUserCredentials(this.$route.params.id)
        .then(response => {
          if (response.status === 200) {
            this.credentialsList = response.data.data;
            this.credentialsLoaded = true;
            return true;
          }
          return false;
        })
        .catch(error => {
          this.credentialsLoaded = false;
          return error;
        })
        .finally(() => {
          this.loadingCredentials = false;
        });
    },
    uploadCredential() {
      this.isUploadingCredential = true;
      this.credentialUploaded = false;
      const credentialsItem = {
        user_id: this.$route.params.id,
        title:
          this.credentialData.title === "other"
            ? this.title
            : this.credentialData.title,
        file: this.credentialData.file
      };
      this.title = "";
      this.validate(credentialsItem, user.credentials);
      if (Object.keys(this.issues).length > 0) {
        this.errors = this.issues;
        this.isUploadingCredential = false;
        return false;
      }
      uploadCredential(this.$route.params.id, credentialsItem)
        .then(response => {
          if (response.status === 201) {
            this.credentialsList.push({ ...response.data, status: 0 });
            this.credentialUploaded = true;
            this.updateUserObject({ is_credential_uploaded: 1 });
            this.credentialData = { title: "" };
            this.errors = {};
            return true;
          }
          this.credentialUploaded = false;
          return false;
        })
        .catch(error => {
          this.credentialUploaded = false;
          return error;
        })
        .finally(() => {
          this.isUploadingCredential = false;
        });
      return true;
    },
    addCredential() {
      this.clearErrors("file");
      const img = this.$refs.credentials.files[0];
      const imgSize = 3 * 2 ** 20;

      if (img && img.type.match(/image\/*/) && img.size > imgSize) {
        errors.credentials = "File size greater than 3MB";
        return false;
      }
      const reader = new FileReader();
      reader.onload = e => {
        this.credentialData.file = e.target.result;
      };
      reader.readAsDataURL(img);
      return true;
    },
    uploadAvatar(file) {
      this.avatarUploaded = false;
      updateAvatar(this.$route.params.id, file)
        .then(response => {
          if (response.status === 200) {
            this.itemData.avatar = file;
            this.avatarUploaded = true;
            return true;
          }
          this.avatarUploaded = false;
          return false;
        })
        .catch(error => {
          this.avatarUploaded = false;
          return error;
        })
        .finally(() => {
          this.isUploadingAvatar = false;
        });
      return true;
    },
    /**
     * Checks for image format and if image size < 3MB
     */
    changeAvatar() {
      this.isUploadingAvatar = true;
      const img = this.$refs.avatar.files[0];
      const imgSize = 3 * 2 ** 20;

      if (img && img.type.match(/image\/*/) && img.size > imgSize) {
        errors.avatar = "File size greater than 3MB";
        return false;
      }
      const reader = new FileReader();
      reader.onload = e => {
        this.avatar = e.target.result;
        this.uploadAvatar(this.avatar);
      };
      reader.readAsDataURL(img);
      return true;
    },
    getUserProfile() {
      this.loadingUser = true;
      getUserProfile(this.$route.params.id)
        .then(response => {
          if (response.status === 200) {
            this.itemData = response.data.data;
            this.courses = response.data.data.classes;
            this.setUserCourses(this.courses);
            this.bank = response.data.data.bank;
            return true;
          }
          this.userLoaded = false;
          return false;
        })
        .catch(error => {
          this.userLoaded = false;
          return error;
        })
        .finally(() => {
          this.loadingUser = false;
        });
    },
    updateUser() {
      const { fname, lname } = this.itemData;
      /**
       * Validate input
       */
      this.validate({ fname, lname }, user.update);
      if (Object.keys(this.issues).length > 0) {
        this.errors = this.issues;
        return false;
      }
      updateUser(this.$route.params.id, { fname, lname })
        .then(response => {
          if (response.status === 200) {
            success({
              title: "Success! Account has been successfully updated."
            });
          }
          this.loading = false;
        })
        .catch(error => {
          fail({
            title: "Oops! Something went wrong",
            text: error.data
          });
          this.loading = false;
        });
      return true;
    },
    credentialStatus(statusNo) {
      const status = statusNo === 0 ? "Unapproved" : "Approved";
      return status;
    },
    updateBank() {
      const result = this.bank;

      ["created_at", "updated_at", "id", "user_id"].forEach(key => {
        delete result[key];
      });
      this.validate(result, user.bank);
      if (Object.keys(this.issues).length > 0) {
        this.errors = this.issues;
        return false;
      }

      updateBank(this.$route.params.id, result)
        .then(response => {
          if (response.status === 200) {
            success({
              title: "Success! Bank details has been successfully updated."
            });
          }
          this.loading = false;
        })
        .catch(error => {
          fail({
            title: "Oops! Something went wrong",
            text: error.data
          });
          this.loading = false;
        });
      return true;
    },
    selectCredential(item) {
      eventHub.$emit("credential-selected", item);
      this.showCredential = true;
    },
    deleteCredential(item) {
      deleteCredential(item.id, this.$route.params.id)
        .then(response => {
          if (response.status === 200) {
            success({
              title: "Success! Credential has been deleted!"
            });
            this.credentialsList.splice(this.credentialsList.indexOf(item), 1);
            return true;
          }
          return false;
        })
        .catch(error => {
          fail({
            title: "Oops! Something went wrong",
            text: error.data
          });
          return false;
        });
      return true;
    },
    getUserJobs() {
      getUserJobs(this.userObject.id)
        .then(response => {
          if (response.status === 200) {
            this.jobs = response.data.data;
            this.jobsLoaded = true;
            return true;
          }
          this.jobsLoaded = false;
          return false;
        })
        .catch(error => {
          this.jobsLoaded = false;
          return error;
        })
        .finally(() => {
          this.loadingJobs = false;
        });
      return true;
    },
    ...mapMutations(["updateUserObject", "setUserCourses"])
  },
  computed: {
    ...mapGetters(["userObject"]),
    fullName() {
      return `${this.userObject.fname} ${this.userObject.lname}`;
    }
  },
  components: {
    Loader,
    Certificate,
    CredentialModal,
    Reports
  },
  filters: {
    date(value) {
      return moment(value).fromNow();
    }
  }
};
</script>

<style lang="scss" scoped>
.div__loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.avatar__input {
  display: none;
}
.loading {
  display: inline-flex;
  width: 50%;
  position: absolute;
  justify-content: center;
  &--alt {
    top: 40%;
    max-width: max-content;
  }
}
.edit-icon {
  margin-bottom: 0;
  &:hover {
    cursor: pointer;
  }
}
.btn__grey {
  max-height: 40px;
  &.btn__primary--lg {
    max-height: 50px;
  }
}
.upload {
  &__wrapper {
    position: relative;
    overflow: hidden;
    display: inline-block;
    display: flex;
    flex-direction: column;
  }
}
.upload__input {
  top: 0;
  font-size: 12px;
  margin: auto;
  bottom: 0;
  left: 0;
  @media #{$mobile} {
    margin-left: 0;
    margin-bottom: 10px;
  }
  &:hover {
    cursor: pointer;
  }
}
.certificate__img {
  width: 172px;
  height: 115px;
  object-fit: cover;
  &:hover {
    cursor: pointer;
  }
  &:focus {
    cursor: pointer;
  }
}
.btn {
  &__green {
    background: $green;
    margin-top: 10px;
    border: none;
    height: 40px;
    display: block;
    &:hover {
      background: $green;
    }
    &:focus {
      box-shadow: none;
    }
    &:active {
      outline: none;
      background: $green;
      box-shadow: none;
    }
  }
  &__danger {
    background: $white;
    color: #dc3545;
    border: 1px solid #dc3545;
    &:hover {
      color: $white;
      background: #dc3545;
    }
  }
  &--wrap {
    display: flex;
    justify-content: flex-end;
    margin-right: 30px;
  }
}

.nav-link {
  display: block;
  @media #{$mobile} {
    padding: 0.5rem 0.4rem;
    text-overflow: ellipsis;
    height: 100%;
  }
}
.form__wrapper {
  margin-left: 20px;
  border: none;
}
.courses__tabs .tab-content {
  padding-right: 20px;
}
.credentials {
  &__status {
    font-size: 14px;
    flex: 0 1 48%;
  }
  &__title {
    flex: 1 0 40%;
    @media #{$mobile} {
      flex: 1 0 40%;
    }
  }
  &__btn-grp {
    button {
      height: 24px;
      margin-left: 15px;
      margin-bottom: 5px;
      font-size: 12px;
    }
  }
}

.badges__item {
  margin-bottom: 20px;
  margin-right: 0px;
  max-width: 100px;
  text-align: center;
  font-size: 12px;
  img {
    width: 60px;
    height: 60px;
    border-radius: 100%;
  }
}
.certificate {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 30px 25px;
}
.vid {
  &__wrapper {
    background-color: rgba(0, 0, 0, 0.8);
    overflow: scroll;
    position: fixed;
    display: none;
    z-index: 1;
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
  }
  &__embed {
    position: relative;
    overflow: hidden;
    height: 0;
    padding-top: 30px;
    padding-bottom: 56.25%;
  }
  &__lightbox {
    position: relative;
    display: block;
    max-width: 960px;
    height: auto;
    z-index: 20;
    margin: 50px auto;
    padding: 0 5%;
  }
}
.btn {
  &__close {
    position: absolute;
    background: transparent;
    font-size: 12px;
    display: block;
    border: none;
    color: $white;
    top: -20px;
    right: 7%;
  }
}
.video__embed iframe,
.video__embed object,
.video__embed embed {
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
}
.badges__wrapper {
  margin-bottom: 20px;
}
</style>
